module.exports = __webpack_public_path__ + "img/11_120.24041e7a.png";